import AccessTimeIcon from "@mui/icons-material/AccessTime";
import AssessmentIcon from "@mui/icons-material/Assessment";
import BadgeIcon from "@mui/icons-material/Badge";
import PaymentsIcon from "@mui/icons-material/Payments";
import SettingsIcon from "@mui/icons-material/Settings";
import Agency from "@mui/icons-material/SourceOutlined";
import UserGroup from "@mui/icons-material/GroupAddOutlined";
import Home from "@mui/icons-material/Home";
import { ROUTES } from "config/index";
import EmployeeWorkspace from "pages/EmployeeWorkspace";
import CostCenters from "features/maintenance/pages/CostCenters";
import Organisations from "features/maintenance/pages/Organisations";
import EmployeePositions from "features/maintenance/pages/EmployeePositions";
import UserGroups from "features/maintenance/pages/UserGroups";
import RegisterUsers from "features/maintenance/pages/RegisterUsers";

import HomePage from "pages/Home";
import LoanTypes from "features/maintenance/pages/LoanTypes";
import LeaveTypes from "features/maintenance/pages/LeaveTypes";
import Holidays from "features/maintenance/pages/Holidays";
import Signatories from "features/maintenance/pages/Signatories";
import Trainings from "features/maintenance/pages/Trainings";
import ChangePassword from "features/maintenance/pages/ChangePassword";
import EmploymentStatus from "features/maintenance/pages/EmploymentStatus";
import EmployeePayClass from "features/maintenance/pages/EmployeePayClass";
import EmployeeListPage from "pages/Employees/pages/EmployeeListPage";
import TaxSchedule from "features/maintenance/pages/TaxSchedule";

const menu = [
    {
        id: "home",
        name: "Home",
        path: ROUTES.DASHBOARD,
        icon: Home,
        requiredPermissions: ["all"],
        element: <HomePage />,
        children: []
    },
    {
        id: "maintenance",
        name: "Maintenance",
        path: ROUTES.MAINTENANCE,
        icon: SettingsIcon,
        requiredPermissions: ["maintenance.view"],
        children: [
            {
                id: "agency-information",
                name: "Agency Information",
                path: ROUTES.MAINTENANCE_AGENCY_INFORMATION,
                element: <Organisations />,
                requiredPermissions: ["agencyInfo.view"]
            },
            {
                id: "department",
                name: "Department",
                path: ROUTES.MAINTENANCE_DEPARTMENT,
                element: <CostCenters />,
                requiredPermissions: ["department.view"]
            },
            {
                id: "department-signatories",
                name: "Department Signatories",
                path: ROUTES.MAINTENANCE_SIGNATORIES,
                requiredPermissions: ["signatories.view"],
                element: <Signatories />
            },
            {
                id: "position",
                name: "Position",
                path: ROUTES.MAINTENANCE_POSITION,
                requiredPermissions: ["position.view"],
                element: <EmployeePositions />,
                break: true
            },
            {
                id: "employment-status",
                name: "Employee Status",
                path: ROUTES.MAINTENANCE_EMPLOYMENT_STATUS,
                requiredPermissions: ["loanType.view"],
                element: <EmploymentStatus />
            },
            {
                id: "employee-pay-class",
                name: "Pay Class",
                path: ROUTES.MAINTENANCE_EMPLOYEE_PAY_CLASS,
                requiredPermissions: ["loanType.view"],
                element: <EmployeePayClass />
            },
            {
                id: "training",
                name: "Training",
                path: ROUTES.MAINTENANCE_TRAINING,
                requiredPermissions: ["training.view"],
                element: <Trainings />
            },
            {
                id: "loan-type",
                name: "Loan Type",
                path: ROUTES.MAINTENANCE_LOAN_TYPE,
                requiredPermissions: ["loanType.view"],
                element: <LoanTypes />,
                break: true
            },
            {
                id: "leave-type",
                name: "Leave Type",
                path: ROUTES.MAINTENANCE_LEAVE_TYPE,
                requiredPermissions: ["leaveType.view"],
                element: <LeaveTypes />
            },
            {
                id: "holidays",
                name: "Holidays",
                path: ROUTES.MAINTENANCE_HOLIDAYS,
                requiredPermissions: ["holidays.view"],
                element: <Holidays />
            },
            {
                id: "tax-schedule",
                name: "Tax Schedule",
                path: ROUTES.MAINTENANCE_TAX_SCHEDULE,
                requiredPermissions: ["taxSchedule.view"],
                element: <TaxSchedule />,
                break: true
            }
        ]
        /*children: [
            {
                id: "code-reference",
                name: "Master Data",
                path: ROUTES.MAINTENANCE_CODE_REFERENCE,
                requiredPermissions: ["codeReference.view"],
                icon: Agency,
                children: [
                    {
                        id: "agency-information",
                        name: "Agency Information",
                        path: ROUTES.MAINTENANCE_AGENCY_INFORMATION,
                        element: <Organisations />,
                        requiredPermissions: ["agencyInfo.view"]
                    },
                    {
                        id: "department",
                        name: "Department",
                        path: ROUTES.MAINTENANCE_DEPARTMENT,
                        element: <CostCenters />,
                        requiredPermissions: ["department.view"]
                    },
                    {
                        id: "position",
                        name: "Position",
                        path: ROUTES.MAINTENANCE_POSITION,
                        requiredPermissions: ["position.view"],
                        element: <EmployeePositions />
                    },
                    {
                        id: "loan-type",
                        name: "Loan Type",
                        path: ROUTES.MAINTENANCE_LOAN_TYPE,
                        requiredPermissions: ["loanType.view"],
                        element: <LoanTypes />
                    },
                    {
                        id: "leave-type",
                        name: "Leave Type",
                        path: ROUTES.MAINTENANCE_LEAVE_TYPE,
                        requiredPermissions: ["leaveType.view"],
                        element: <LeaveTypes />
                    },
                    {
                        id: "training",
                        name: "Training",
                        path: ROUTES.MAINTENANCE_TRAINING,
                        requiredPermissions: ["training.view"],
                        element: <Trainings />
                    },
                    {
                        id: "holidays",
                        name: "Holidays",
                        path: ROUTES.MAINTENANCE_HOLIDAYS,
                        requiredPermissions: ["holidays.view"],
                        element: <Holidays />
                    },
                    {
                        id: "department-signatories",
                        name: "Department Signatories",
                        path: ROUTES.MAINTENANCE_SIGNATORIES,
                        requiredPermissions: ["signatories.view"],
                        element: <Signatories />
                    },
                    {
                        id: "payroll-period",
                        name: "Payroll Period",
                        path: ROUTES.MAINTENANCE_PAYROLL_PERIOD,
                        requiredPermissions: ["payrollPeriod.view"]
                    }
                ]
            }
        ]*/
    },
    {
        id: "user-maintenance",
        name: "User Management",
        path: ROUTES.MAINTENANCE_USER_MAINTENANCE,
        requiredPermissions: ["userMaintenance.view"],
        icon: UserGroup,
        children: [
            {
                id: "user-group",
                name: "User Group",
                path: ROUTES.MAINTENANCE_USER_GROUP,
                requiredPermissions: ["userMaintenance.view"],
                element: <UserGroups />
            },
            {
                id: "users",
                name: "Users",
                path: ROUTES.MAINTENANCE_USERS,
                requiredPermissions: ["userMaintenance.view"],
                element: <RegisterUsers />
            },
            {
                id: "change-password",
                name: "Change Password",
                path: ROUTES.MAINTENANCE_USERS_CHANGE_PASSWORD,
                requiredPermissions: ["all"],
                element: <ChangePassword />
            }
        ]
    },

    {
        id: "employee",
        name: "Employees",
        path: ROUTES.EMPLOYEES,
        icon: BadgeIcon,
        element: <EmployeeListPage />,
        requiredPermissions: ["employee.view", "payrollEmployee.view"]
        /*children: [
            {
                id: "personal-data-sheet",
                name: "Employee List",
                path: ROUTES.EMPLOYEES_NEW,
                element: <EmployeeWorkspace />,
                requiredPermissions: ["personalDataSheet.view"]
            },
            {
                id: "my-person-profile",
                name: "My Personal Profile",
                path: ROUTES.MY_PROFILE,
                element: <MyDataSheetRedirect />,
                requiredPermissions: ["employee.view"]
            }
        ]*/
    },

    {
        id: "attendance",
        name: "Attendance",
        path: ROUTES.ATTENDANCE,
        icon: AccessTimeIcon,
        requiredPermissions: ["attendance.view"],
        children: [
            {
                id: "download-dtr",
                name: "Download DTR",
                path: ROUTES.ATTENDANCE_DOWNLOAD_DTR,
                requiredPermissions: ["downloadDTR.view"]
            },
            {
                id: "dtr",
                name: "Daily Time Record (DTR)",
                path: ROUTES.ATTENDANCE_DTR,
                requiredPermissions: ["dtr.view"]
            },
            {
                id: "alternative-work-arrangement",
                name: "Alternative Work Arrangement",
                path: ROUTES.ATTENDANCE_ALTERNATIVE_WORK,
                requiredPermissions: ["alternativeWork.view"]
            },
            {
                id: "service-record",
                name: "Service Record Request",
                path: ROUTES.ATTENDANCE_SERVICE_RECORD,
                requiredPermissions: ["serviceRecord.view"]
            },
            {
                id: "learning-training",
                name: "Learning & Development Training",
                path: ROUTES.ATTENDANCE_LEARNING_TRAINING,
                requiredPermissions: ["learningTraining.view"]
            },
            {
                id: "leave-management",
                name: "Leave Management",
                path: ROUTES.ATTENDANCE_LEAVE_MANAGEMENT,
                requiredPermissions: ["leaveManagement.view"]
            },
            {
                id: "attendance-monitoring",
                name: "Attendance Monitoring",
                path: ROUTES.ATTENDANCE_MONITORING,
                requiredPermissions: ["attendanceMonitoring.view"]
            }
        ]
    },

    {
        id: "payroll",
        name: "Payroll",
        path: ROUTES.PAYROLL,
        icon: PaymentsIcon,
        requiredPermissions: ["payroll.view"],
        children: [
            {
                id: "payroll-processing",
                name: "Payroll Processing",
                path: ROUTES.PAYROLL_PROCESSING,
                requiredPermissions: ["payrollProcessing.view"]
            },
            {
                id: "payroll-adjustment",
                name: "Payroll Adjustment",
                path: ROUTES.PAYROLL_ADJUSTMENTS,
                requiredPermissions: ["payrollAdjustment.view"]
            },
            {
                id: "payroll-period",
                name: "Payroll Period",
                path: ROUTES.MAINTENANCE_PAYROLL_PERIOD,
                requiredPermissions: ["payrollPeriod.view"]
            }

            /* {
                 id: "payroll-employee",
                 name: "Employee Rate",
                 path: ROUTES.EMPLOYEES,
                 element: <EmployeeListPage />,
                 requiredPermissions: ["payrollEmployee.view"]
             }*/
        ]
    },

    {
        id: "reports",
        name: "Reports",
        path: ROUTES.REPORTS,
        icon: AssessmentIcon,
        requiredPermissions: ["reports.view"],
        children: [
            {
                id: "employees-master-list",
                name: "Employees Master List",
                path: ROUTES.REPORTS_EMPLOYEES,
                requiredPermissions: ["employeesMasterList.view"]
            },
            {
                id: "personnel-data-sheet",
                name: "Personnel Data Sheet",
                path: ROUTES.REPORTS_PERSONNEL_DATA_SHEET,
                requiredPermissions: ["personnelDataSheet.view"]
            }
        ]
    }
];

export default menu;
